import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTextAlignmentLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.774 7.5a.75.75 0 0 1 0-1.5h16.48a.75.75 0 0 1 0 1.5zm-.006 7a.75.75 0 0 1 0-1.5h16.478a.75.75 0 1 1 0 1.5zm-.75-4.25c0 .414.336.75.75.75h11.334a.75.75 0 1 0 0-1.5H3.768a.75.75 0 0 0-.75.75m.75 7.75a.75.75 0 0 1 0-1.5h11.334a.75.75 0 1 1 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentLeft24);
